export interface ApplicationConfig {
    apiURL: string;
    apiDevURL: string;
    authURL: string,
    authDevURL: string,
    appName: string;
    version: string;
    releasedDate: string;
  }

export const CONFIG: ApplicationConfig = {
    apiURL: 'https://allograftpath.upmc.com/BanffAllograftServer/',
    //apiURL: 'https://allograftpathtest.upmc.com/TemplatesServer/',
    //apiURL: 'http://localhost:48888/',
    apiDevURL: 'http://localhost:48888/',
    authURL: 'https://allograftpath.upmc.com/AuthenticationServer/',
    //authURL: 'https://allograftpathtest.upmc.com/AuthenticationServer/',
    //authURL: 'http://localhost:48899/',
    authDevURL: 'http://localhost:48899/',
    appName: 'Smart Template Scoring System',
    version: '1.1.5',
    releasedDate: 'March 24, 2024'
  };
